import React, {useState, useEffect, useRef} from 'react';
import Message from './components/Message';
import {getResponse} from '../util/ChatBot';
import TextInput from "./components/TextInput";
const ChatWindow = ({firstMessage, addNotification, conversationID, setConversationID, safeguardingCID, setSafeguardingCID, ...props}) => {

  const [greeted, setGreeted] = useState(false);
  const [answered, setAnswered] = useState(false);
  const [input, setInput] = useState('');
  const [allowInput, setAllowInput] = useState(true);
  const [messages, setMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(true);
  const [events, setEvents] = useState([]);
  const [inputDisabled, setInputDisabled] = useState('disabled');
  const [language, setLanguage] = useState('English');

  const getLoaderClassnames = (isTyping) => {
    if (isTyping) {
      return 'loader';
    }
    return 'loader hidden';
  };

  const getOptionsClasses = () => {
    if (answered || !greeted) {
      return 'premade-responses hidden';
    }
    return 'premade-responses';
  };
  const onKeyUp = (e) => {
    if (e.keyCode === 13) {
      if (input !== '') {
        onSendMessage(e.target);
      }
    }
    else {
      setInput(e.target.value);
    }
  };

  const onSendMessage = (inputField) => {
    // If the user presses enter, send the message.
    var m = input;
    sendMessage({
      type: 'human',
      sender: 'You',
      content: m,
      time: new Date().toLocaleTimeString()
    });
    setInput('');
    setAnswered(true);
    if (inputField) {
      inputField.value = '';
    }
    //
    (async () => {
      setIsTyping(true);
      var request = await getResponse([{
        content: m,
        role: 'user',
      }], conversationID, language, safeguardingCID);
      var response = request.content;
      setIsTyping(false);
      setEvents(events => [response.events, ...events]);
      if (response.messages) {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'chatbot_message_sent',
            conversationID: conversationID
          });
        }
        var responseKeys = Object.keys(response.messages);
        for (var i = 0; i < responseKeys.length; i++) {
          sendMessage({
            type: 'bot',
            sender: 'IE Chatbot',
            content: response.messages[responseKeys[i]],
            time: new Date().toLocaleTimeString()
          });
        }
      }

      if (response.notifications) {
        response.notifications.forEach(notification => {
          notification.read = false;
          addNotification(notification);
        });
      }

      if (response.disable) {
        setAllowInput(false);
      }
    })()
  };

  useEffect(() => {
    if (allowInput) {
      setInputDisabled('');
    }
    else {
      setInputDisabled('disabled');
    }
  }, [allowInput]);

  const sendMessage = (message) => {
    setMessages(messages => [message, ...messages]);
  }

  const sendPremade = (response) => {
    setInput(response);
    setAnswered(true);
  };

  useEffect(() => {
    if (input) {
      onSendMessage();
    }
  }, [answered]);

  useEffect( () => {
    if (!greeted) {
      (async () => {

        sendMessage({
          type: 'human',
          sender: 'You',
          content: firstMessage,
          time: new Date().toLocaleTimeString()
        });

        var request = await getResponse([{ content: firstMessage, role: 'user', skipTranslate: true }], conversationID, language);

        if (request.conversationID) {
          setConversationID(request.conversationID);
        }

        if (request.safeguardingCID) {
          setSafeguardingCID(request.safeguardingCID);
        }

        var response = request.content;
        if (response.messages) {
          var responseKeys = Object.keys(response.messages);
          for (var i = 0; i < responseKeys.length; i++) {
            sendMessage({
              type: 'bot',
              sender: 'IE Chatbot',
              content: response.messages[responseKeys[i]],
              time: new Date().toLocaleTimeString()
            });
          }
        }
        setGreeted(true);
        setIsTyping(false);
      })();
    }
  }, []);

  return (
    <div className={props.className}>
      <span id="ie-chatbot-conversation-id">{conversationID}</span>
      <div className="chat-panel h-full border-1 rounded-[25px] bg-white text-black">
        <div className="panel--body h-full flex flex-col justify-end">
          <div data-lenis-prevent className="panel--content flex flex-col-reverse h-96 grow overflow-auto p-6">
            <Message className={getLoaderClassnames(isTyping)} sender={'IE Chatbot'}>
              <div className="loader-dots flex flex-row gap-[10px] [&_div]:bg-white [&_div]:w-[15px] [&_div]:h-[15px] [&_div]:rounded-full">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </Message>
            {messages.map((message, index) => {
              return <Message className={message.type} sender={message.sender} time={message.time} key={index}>{message.content}</Message>
            })}
          </div>
          <div className="chat-panel--input">
            <TextInput inputDisabled={inputDisabled} submit={onSendMessage} onKeyUp={onKeyUp} />
          </div>
        </div>
      </div>
    </div>
  );

};

export default ChatWindow;
